import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Slider } from "@/components/ui/slider";
import { HardDrive, ArrowRight } from "lucide-react";

const PLANS = [
  { key: "starter", name: "Starter", tb: 1, price: 49 },
  { key: "pro", name: "Pro", tb: 2, price: 89 },
  { key: "business", name: "Business", tb: 5, price: 179 },
  { key: "business10", name: "Business 10", tb: 10, price: 299 },
];

export default function PricingCalculator() {
  const [tb, setTb] = useState(5);
  const nav = useNavigate();

  const rec = useMemo(() => {
    const fit = PLANS.find((p) => p.tb >= tb);
    if (fit) return { ...fit, custom: false, price: fit.price };
    const extra = tb - 10;
    return { name: "Business 10 + overage", key: "business10", tb, custom: true, price: 299 + extra * 20 };
  }, [tb]);

  const dedup = Math.round(tb * 2.4 * 10) / 10;

  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/50 p-6 sm:p-8">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-cyan-400">Pricing Calculator</div>
          <h3 className="mt-1 font-display text-xl font-bold text-slate-100">How much data do you need protected?</h3>
        </div>
        <HardDrive className="hidden h-8 w-8 text-cyan-500/50 sm:block" />
      </div>

      <div className="mb-2 flex items-end justify-between">
        <span className="font-mono text-3xl font-bold text-cyan-300" data-testid="calc-tb-value">{tb} TB</span>
        <span className="text-sm text-slate-500">1 TB – 100 TB</span>
      </div>
      <Slider min={1} max={100} step={1} value={[tb]} onValueChange={(v) => setTb(v[0])}
        className="my-4" data-testid="pricing-calculator-slider" />

      <div className="mt-6 grid grid-cols-3 gap-3">
        <div className="rounded-lg border border-slate-800 bg-[#06080D] p-3">
          <div className="text-xs text-slate-500">Recommended</div>
          <div className="mt-1 font-display text-sm font-semibold text-slate-100">{rec.name}</div>
        </div>
        <div className="rounded-lg border border-slate-800 bg-[#06080D] p-3">
          <div className="text-xs text-slate-500">Est. monthly</div>
          <div className="mt-1 font-mono text-sm font-semibold text-emerald-300" data-testid="calc-price">${rec.price}/mo</div>
        </div>
        <div className="rounded-lg border border-slate-800 bg-[#06080D] p-3">
          <div className="text-xs text-slate-500">Logical protected*</div>
          <div className="mt-1 font-mono text-sm font-semibold text-slate-100">~{dedup} TB</div>
        </div>
      </div>
      <p className="mt-3 text-xs text-slate-500">*With typical Proxmox deduplication (~2.4×), your {tb} TB plan protects far more logical data. Not sure? Start small and expand at any time.</p>

      <button onClick={() => nav("/signup")} data-testid="calc-cta"
        className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-cyan-400 px-5 py-3 font-semibold text-[#06080D] transition-all hover:bg-cyan-300">
        Deploy {rec.name} <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
}
